import { render } from "./TicketsTicket.vue?vue&type=template&id=48777ec6"
import script from "./TicketsTicket.vue?vue&type=script&lang=ts"
export * from "./TicketsTicket.vue?vue&type=script&lang=ts"
script.render = render

export default script